import { render, staticRenderFns } from "./SingleUserView.vue?vue&type=template&id=22c02c85&scoped=true&"
import script from "./SingleUserView.vue?vue&type=script&lang=ts&"
export * from "./SingleUserView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c02c85",
  null
  
)

export default component.exports